module.exports = __webpack_public_path__ + "static/media/crackersnCheese.f6b1182c.png";